'use strict';

module Patersons {

    export class BaseService {
        http: ng.IHttpService;
        log: ng.ILogService;
        baseUrl: string;
        tokenService: TokenService;
        state: angular.ui.IStateService;
        q: ng.IQService;

        static $inject = ['$http', '$log', '$state', '$q', 'tokenService'];

        constructor($http, $log, $state, $q, tokenService) {
            this.http = $http;
            this.log = $log;
            this.tokenService = tokenService;
            this.state = $state;
            this.q = $q;
            var model: string = document.getElementById("model").textContent.trim();
            var dictionary: any = JSON.parse(model);
            this.baseUrl = dictionary['hostPath'];
        }

        get(url: string): ng.IPromise<any> {
            var absoluteUrl: string = this.baseUrl + url;

            this.log.info("GET - " + absoluteUrl);

            let cancel: ng.IDeferred<{}> = this.q.defer();
            let config = {
              timeout: cancel.promise,
              cancel: cancel,
              headers : {
                /*"Pragma": "no-cache",
                "Expires": -1,
                "Cache-Control": "no-cache"*/
              }
            };

            return this.http.get(absoluteUrl, config)
                .then((response) => {
                    return this.mapResponseData(response);
                },
                (reason) => {
                    return this.errorHandler(reason, "Error calling GET on " + absoluteUrl);
                });
        }

        post(url: string, data: any) {
            var absoluteUrl: string = this.baseUrl + url;

            this.log.info("POST - " + absoluteUrl);
            this.log.info(data);
            return this.http.post(absoluteUrl, data)
                .then((response) => {
                    return this.mapResponseData(response);
                },
                (reason) => {
                    return this.errorHandler(reason, "Error calling POST on " + absoluteUrl);
                });
        }

        patch(url: string, data: any) {
            var absoluteUrl: string = this.baseUrl + url;

            this.log.info("PATCH - " + absoluteUrl);
            this.log.info(data);

            return this.http.patch(absoluteUrl, data)
                .then((response) => {
                    return this.mapResponseData(response);
                },
                (reason) => {
                    return this.errorHandler(reason, "Error calling PATCH on " + absoluteUrl);
                });
        }

        put(url: string, data: any) {
            var absoluteUrl: string = this.baseUrl + url;

            this.log.info("PUT - " + absoluteUrl);
            this.log.info(data);

            return this.http.put(absoluteUrl, data)
                .then((response) => {
                    return this.mapResponseData(response);
                },
                (reason) => {
                    return this.errorHandler(reason, "Error calling PUT on " + absoluteUrl);
                });
        }

        delete(url: string) {
            var absoluteUrl: string = this.baseUrl + url;

            this.log.info("DELETE - " + absoluteUrl);
            return this.http.delete(absoluteUrl)
                .then((response) => {
                    return this.mapResponseData(response);
                },
                (reason) => {
                    return this.errorHandler(reason, "Error calling DELETE on " + absoluteUrl);
                });
        }

        errorHandler(reason, msg) {
            msg = msg || "Unexpected Error";

            if (reason.data && reason.data.exceptionMessage) {
                this.log.error(reason.data);
            }

            if (reason.status === 401) {
                //Unauthorized
                //Store current URL to redirect back to it after login.
                window.localStorage.setItem('$psl.redirect_uri', window.location.href);
                this.tokenService.tokenManager.redirectForToken();
            }
            if (reason.status === 403) {
                // forbidden
                if (reason.data != 'Please verify code send via SMS') {
                    this.state.go('forbidden');
                }
            }
            /*if (reason.status === 404) {
                // forbidden
                this.state.go('otherwise');
            }*/
            /*if (reason.status === 500) {
                // internal server error
                this.state.go('error');
            }*/
            throw reason;
        }

        mapResponseData(response) {
            console.log(response.config.url);

            if (response.data !== null &&
                response.data !== undefined &&
                response.data.value !== null &&
                response.data.value !== undefined) {
                return response.data.value;
            }
            else if ( response.data !== undefined &&
                      response.data !== null) {
                return response.data;
            }
            else {
                return response;
            }
        }
    }
}
